<template>
	<div class="lxwm">
		<div class="contanier lxtw">
			<div class="wz">
				<img src="../assets/image/wz.jpg" alt="">
			</div>
			<div class="lxwm-r">
				<h2>联系我们</h2>
				<p><i class="icon-landline-orange"></i>电话：0755-82416002</p>
				<p><i class="icon-phone-orange"></i>手机：13411203329</p>
				<p><i class="icon-email-orange"></i>邮箱：784979322@qq.com</p>
				<p><i class="icon-address-orange"></i>地址：深圳市龙岗区平湖街道禾花社区同富路14号A栋2楼、3楼</p>
			</div>
		</div>
		<div class="ditu"></div>
		<div class="liuyan">
			<div class="section-title">
				<h2>给我们留言</h2>
			</div>
			<div class="contanier lyinput">
				<div class="input-item">
					<h4>姓名</h4>
					<input type="text" v-model="name" placeholder="请输入您的姓名">
				</div>
				<div class="input-item">
					<h4>电话</h4>
					<input type="text" v-model="phone" placeholder="请输入您的电话">
				</div>
				<div class="input-item">
					<h4>公司</h4>
					<input type="text" v-model="company" placeholder="请输入您的公司全称">
				</div>
			</div>
			<div class="contanier">
				<div class="textarea-item">
					<h4>留言</h4>
					<textarea v-model="note" placeholder="请输入您的需求"></textarea>
				</div>
				<button class="lybtn" @click="submitEvent">立即提交</button>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data: function() {
			return {
				phone: '',
				name: '',
				company: '',
				note: '',
				msg: ''
			}
		},
		methods: {
			submitEvent() {
				var data = {
					phone: this.phone,
					name: this.name,
					company: this.company,
					note: this.note
				};

				if (data.phone && data.name && data.company) {
					this.axios.get("savePotential", {
						params: data
					}).then(res => {
						console.log(res);
						if (res.data.code == 'success') {
							alert('提交成功')
						} else {
							alert(res.data.msg)
						}
					})
				} else {
					alert('请填写完整')
				}
			}
		}
	}
</script>
<style lang="less">
	@import '../assets/css/main.less';

	.lxtw {
		display: flex;
		padding-top: @secction-padding ;

		.lxwm-r {
			margin-left: 30px;
			padding-top: @secction-padding ;
		}

		h2 {
			margin-bottom: 30px;
		}

		p {
			margin-bottom: 15px;
		}

		i {
			margin-right: 10px;
		}
	}

	.liuyan {
		border-top: 1px dashed #eee;
		padding-bottom: @secction-padding;

		.lyinput {
			display: flex;
			justify-content: space-between;
		}

		.input-item {
			width: 30%;
		}

		input {
			height: 40px;
			width: 100%;
			margin-top: 8px;
			margin-bottom: 30px;
			padding-left: 10px;
			border: 1px solid #ddd;
			outline: none;
			border-radius: 3px;
		}

		textarea {
			line-height: 40px;
			height: 120px;
			width: 100%;
			border: 1px solid #ddd;
			outline: none;
			margin-top: 8px;
			margin-bottom: 30px;
			padding-left: 10px;
			border-radius: 3px;
		}

		.lybtn {
			width: 120px;
			height: 40px;
			background-color: @theme-color;
			color: @white-color;
			border: none;
			font-size: 18px;
			border-radius: 3px;
		}
	}
</style>
